
import { useMediaQuery } from './use-media-query';
import { useEffect, useState } from 'react';

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  browserName: string;
  isIOS: boolean;
  isAndroid: boolean;
  isSafari: boolean;
}

export function useDevice(): DeviceInfo {
  const isMobileQuery = useMediaQuery('(max-width: 640px)');
  const isTabletQuery = useMediaQuery('(min-width: 641px) and (max-width: 1024px)');
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    browserName: '',
    isIOS: false,
    isAndroid: false,
    isSafari: false,
  });

  useEffect(() => {
    const ua = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isAndroid = /android/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    
    let browserName = 'unknown';
    if (ua.indexOf('firefox') > -1) browserName = 'firefox';
    else if (ua.indexOf('chrome') > -1) browserName = 'chrome';
    else if (ua.indexOf('safari') > -1) browserName = 'safari';
    else if (ua.indexOf('edge') > -1) browserName = 'edge';
    
    setDeviceInfo({
      isMobile: isMobileQuery,
      isTablet: isTabletQuery,
      isDesktop: !isMobileQuery && !isTabletQuery,
      browserName,
      isIOS,
      isAndroid,
      isSafari,
    });
  }, [isMobileQuery, isTabletQuery]);

  return deviceInfo;
}
